package fr.frux.core.common.auth

import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

/**
 * Canal d'expiration de session entre la couche réseau et le domaine (#48).
 *
 * Il vit dans `core-common` et non dans `:shared` pour casser le cycle : `core-network`, qui
 * l'émet, ne peut pas dépendre de `:shared`, où vit le `SessionStore` qui le consomme.
 *
 * `replay = 0` + buffer 1 en `DROP_OLDEST` : une rafale de 401 concurrents (plusieurs écrans qui
 * requêtent en même temps) ne doit pas constituer une file d'expirations à rejouer.
 */
@SingleIn(AppScope::class)
@Inject
class SessionExpiryNotifier {

    private val _events = MutableSharedFlow<Unit>(
        replay = 0,
        extraBufferCapacity = 1,
        onBufferOverflow = BufferOverflow.DROP_OLDEST,
    )

    val events: SharedFlow<Unit> = _events.asSharedFlow()

    /** Appelé depuis le validateur HTTP : non suspendu, appelable depuis n'importe quel contexte. */
    fun notifyExpired() {
        _events.tryEmit(Unit)
    }
}
